import React from 'react';
import PropTypes from 'prop-types';

import {Form} from 'formik';

import {useNavigate} from 'react-router-dom';

import {ButtonPrimary, ButtonSecondary} from 'pac-ux-components';

import {Box, Group} from '@mantine/core';

const ActionbarMode = Object.freeze({
                                        edit: 'edit',
                                        view: 'view',
                                    });

const ActionBar = ({mode, secondaryAction, primaryAction}) => {
    return (
        <Group position="right">
            <ButtonSecondary
                disabled={mode === ActionbarMode.view}
                onClick={secondaryAction.action}
            >
                {secondaryAction.label}
            </ButtonSecondary>

            <ButtonPrimary
                disabled={mode === ActionbarMode.view}
                onClick={primaryAction.action}
            >
                {primaryAction.label}
            </ButtonPrimary>
        </Group>
    );
};

export const FormWithActionBar = ({handleSubmit, handleCancel, children}) => {
    const navigate = useNavigate();

    let onCancel = null;
    if (handleCancel) {
        onCancel = handleCancel;
    } else {
        onCancel = (e) => {
            e.preventDefault();
            navigate(-1);
        };
    }

    return (
        <Form onSubmit={handleSubmit}>
            {children}

            <Box mt="xl">
                <ActionBar
                    mode={ActionbarMode.edit}
                    primaryAction={{
                        label: 'Save', action: () => {
                            console.debug('action in form with action bar')
                        }
                    }}
                    secondaryAction={{
                        label: 'Cancel',
                        action: onCancel,
                    }}
                />
            </Box>
        </Form>
    );
};

FormWithActionBar.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func,
    children: PropTypes.node,
};

ActionBar.propTypes = {
    mode: PropTypes.oneOf([ActionbarMode.edit, ActionbarMode.view]),
    primaryAction: PropTypes.shape({
                                       label: PropTypes.string,
                                       action: PropTypes.func,
                                   }).isRequired,
    secondaryAction: PropTypes.shape({
                                         label: PropTypes.string,
                                         action: PropTypes.func,
                                     }).isRequired,
};

ActionBar.defaultProps = {
    mode: ActionbarMode.edit,
};

ActionBar.displayName = 'ActionBar';
